import React from 'react';
import './LinedTitle.scss';

const LinedTitle = ({ title }) => {
  return (
    <div className="lined__title">
      <h3 className="title__text">{title}</h3>
      <div className="title__line"></div>
    </div>
  );
};

export default LinedTitle;